import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import isRecord from "~/helpers/isRecord";

export const EMAIL_ISSUES_SOURCE_KIND = "emailIssues";

export const EMAIL_SEND_TARGET_KIND = "emailSend";

export const EMAIL_ISSUES_PATH = "/reports/email-issues";

const EMAIL_SEND_ROUTE_PATTERN = /^\/reports\/email-issues\/([^/?#]+)$/;

export interface EmailIssuesSourceCheckpoint {
	emailSendId: null | string;
	includeUnconfirmed: boolean;
	searchText: string;
	subject: string;
}

export const isEmailIssuesSourceCheckpoint = (value: unknown): value is EmailIssuesSourceCheckpoint =>
	isRecord(value) &&
	(value.emailSendId === null || typeof value.emailSendId === "string") &&
	typeof value.includeUnconfirmed === "boolean" &&
	typeof value.searchText === "string" &&
	typeof value.subject === "string";

export const buildEmailSendPath = (emailSendId: string): string =>
	`${EMAIL_ISSUES_PATH}/${encodeURIComponent(emailSendId)}`;

export const matchEmailSendReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = EMAIL_SEND_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: EMAIL_SEND_TARGET_KIND };
	} catch {
		return null;
	}
};

export const emailSendReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildEmailSendPath(targetId),
	matchesRoute: matchEmailSendReceiverRoute
};

const emailIssuesEditorKey = (emailSendId: null | string): string => `email-issues:${emailSendId ?? "list"}`;

export default emailIssuesEditorKey;
